import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [{
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/faq',
        name: 'Faq',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import ('../views/Faq.vue') /* webpackChunkName: "about" */
    },
    {
        path: '/analysen',
        name: 'Analysen',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import ('../views/Analysen.vue') /* webpackChunkName: "about" */
    }
]

const router = new VueRouter({
    routes
})

export default router